// Wspólna haptyka feedbacku odpowiedzi.
// Respektuje ustawienie 'vibration_enabled' (analogicznie do 'sound_enabled' w useAudio).
// Natywnie iOS/Android przez @capacitor/haptics, fallback Web Vibration API.
import { Capacitor } from '@capacitor/core';
import { Haptics, NotificationType } from '@capacitor/haptics';

// kind: 'success' | 'error'
export const triggerHaptic = (kind) => {
    if (typeof window === 'undefined') return;
    if (localStorage.getItem('vibration_enabled') === 'false') return;

    if (Capacitor.isNativePlatform()) {
        const type = kind === 'success' ? NotificationType.Success : NotificationType.Error;
        Haptics.notification({ type }).catch(() => {});
        return;
    }

    if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
        navigator.vibrate(kind === 'success' ? 20 : [10, 40, 10]);
    }
};
